window.theme = window.theme || {};
window.slate = window.slate || {};

var prevArrow = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)"/></svg>',
    nextArrow = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)"/></svg>',
    headerHeightDesktop = 86,
    headerHeightMobile = 75;


document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

var addToCart = theme.strings.addToCart,
    addToCartMobile = theme.strings.addToCartMobile,
	preOrder = theme.strings.preOrder,
    preOrderText = theme.strings.preOrderText;

var productPageTriggerBIS = false;

if(getUrlParameter('bis_trigger') == '1') {
  productPageTriggerBIS = true;
  console.log('Trigger BIS');
}

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function(selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery('.single-option-selector:eq(0)');
      break;
    case 1:
      var key = jQuery('.single-option-selector:eq(0)').val();
      var selector = jQuery('.single-option-selector:eq(1)');
      break;
    case 2:
      var key = jQuery('.single-option-selector:eq(0)').val();
      key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
      var selector = jQuery('.single-option-selector:eq(2)');
  }

  var initialValue = selector.val();
  //selector.empty();
  var availableOptions = Shopify.optionsMap[key];
  //console.log(availableOptions);

  jQuery('#sos-SingleOptionSelector-' + selectorIndex + ' .variant-select__option-label').each(function() {
    if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').addClass('available');
    } else {
      $(this).addClass('soldout').removeClass('available');
    }
    
  });
 
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');
};

Shopify.linkOptionSelectors = function(product) {
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = jQuery.unique(Shopify.optionsMap['root']);


      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = jQuery.unique(Shopify.optionsMap[key]);
        //console.log(variant);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = jQuery.unique(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  jQuery(".single-option-selector:eq(0)").change(function() {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery(".single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

String.prototype.imgURL = function(size) {
  // remove any current image size then add the new image size
  return this
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
  	.on('shopify:section:select', function(evt) {
    if (evt.detail.sectionId !== 'sidebar-menu') {
      theme.LeftDrawer.close();
    }
  });
};

var cart;
var collection_cookie;


function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function slugify(text) {
  return text.toString().toLowerCase().trim()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}


function sort_id(a, b){
  return ($(b).attr('id')) < ($(a).attr('id')) ? 1 : -1;
}
function sort_value(a, b){
  return ($(b).attr('value')) < ($(a).attr('value')) ? 1 : -1;
}
function sort_name(a, b){
  return ($(b).data('name')) < ($(a).data('name')) ? 1 : -1;
}

var smallScreen = false;

theme.isMobile = function() {
  var isMobile = false;
  if($(window).width() <= 768) {
    isMobile = true;
    smallScreen = true;
  	addToCart = addToCartMobile;

  }
  return isMobile;
}

theme.onCartPage = function() {
  var onCartPage = false;
  if (window.location.href.indexOf("/cart") > -1) {
    onCartPage = true;
  }
  return onCartPage;
}

var currencyChosenByUser = false;
var euCountryList = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];

theme.checkCountry = function() {
  var selectors = {
    elements: '.country-specific',
    usOnly: '.us--only',
    auOnly: '.au--only',
    intOnly: '.int--only'
  };
  
  function processCountries(country) {
    $(selectors.elements).hide();
    console.log(country);
    if(country != 'US') {
//       $('.ajaxcart__inner--has-fixed-footer').css('top','138px');
      $('.afterpay-paragraph').remove();
    }
    
    switch(country) {
      case 'US':
        $(selectors.usOnly).show();
      	theme.setCurrency('USD');
        theme.davidsAfterpay();
        break;
        
      case 'AU':
        $(selectors.auOnly).show();
      	theme.setCurrency('AUD');
        break;
        
      case 'NZ':
        $(selectors.auOnly).show();
        break;
        
      case 'CA': 
        $(selectors.intOnly).show();
        theme.setCurrency('CAD'); 
        break;
        
      case 'JP': 
        $(selectors.intOnly).show();
        theme.setCurrency('JPY'); 
        break;
        
      default:
        $(selectors.intOnly).show();
        if($.inArray(country,euCountryList) > -1) {
          theme.euCountries();
          if(country == 'GB') {
            theme.setCurrency('GBP');
          } else {
            theme.setCurrency('EUR');
          }
        }
     }
  }
  
  
  if(getUrlParameter('country') != '') {
    Cookies.set('country', getUrlParameter('country'), { expires: 90 });
  }
  
  //No Country Cookie, so let's see where they are
  var userCountry = false;
  var inEU = false;
  /*
  if(Cookies.get('country') == undefined) {
    $.ajax({
      url: '//ipapi.co/json/',
      jsonp: 'callback',
      success: function(response) {
        console.log(response);
        userCountry = response.country;
        Cookies.set('country', userCountry, { expires: 90 });
        processCountries(userCountry);
      },
      error: function(response) {
        console.log(response);
      }
    });
  } else {
    var userCountry = Cookies.get('country');
    processCountries(userCountry);
  }
  */
  //checkCountry.processCountres(country);
};

theme.processCountries = function(country) {
  //Hide country-specific info
  
};

theme.euCountries = function(country) {
  console.log('Do EU Stuff');
  theme.cookiesPopup();
}

theme.setCurrency = function(newCurrency) {
  if(theme.dev.showMultipleCurrencies && currencyChosenByUser == false && Cookies.get('currencyChosenByUser' != 'true')) {
	$('.site-header .currency-picker a[data-currency="'+newCurrency+'"]').trigger('click'); 
  }
};


theme.removeCookies = function() {
  if(getUrlParameter('clearcookies') != '') {
    Object.keys(Cookies.get()).forEach(function(cookie) {
      Cookies.remove(cookie);
    });
  }
};

theme.responsiveTableWrap = function() {
  $('.responsive-table td').wrapInner('<span class="responsive-td-wrap"></span>');
};

theme.davidsAfterpayPopup = function() {
	$('#davids-afterpay-popup').addClass('show');
  	$('.davids-afterpay-close').on
};

theme.closeAfterpayPopup = function() {
}


theme.davidsAfterpay = function() {
  var selectors = {
    cartParagraph: '.davids-afterpay-paragraph',
    productParagraph: '.davids-afterpay-paragraph__pdp',
    installments: '.afterpay-instalments'
  }
  /* Numbers */
  var cart_subtotal = parseInt($('#CartCount .cart-count-number').data('cart-total'));
  var afterpayAmount = parseFloat(cart_subtotal / 4).toFixed(2);
  var product_subtotal = parseInt($('#ProductPrice-product-template').text().replace('$',''));
  var afterpayProductAmount = parseFloat(product_subtotal / 4).toFixed(2);
  var cartFourWays = '$'+afterpayAmount.replace('.00','') + ' USD'
  /* Cart Drawer */
  $('.inline-cart--container').find(selectors.installments).text(cartFourWays);
  var fh = $('.drawer--right .ajaxcart__footer').outerHeight();
  //$('.drawer--right .ajaxcart__inner--has-fixed-footer').css('top',fh);
  
  /* Static Cart */
  $('.cart-sidebar').find(selectors.installments).text(cartFourWays);
  
  $(selectors.cartParagraph + ' a').on('click',function(e) {
    e.preventDefault();
    //console.log("David's popup");
    $('#davids-afterpay-popup').addClass('show');
  });
  
  $(selectors.productParagraph + ' a').on('click',function(e) {
    e.preventDefault();
    //console.log("David's popup");
    $('#davids-afterpay-popup').addClass('show');
  });
  
  $('#davids-afterpay-popup .davids-afterpay-close').on('click',function(e) {
    e.preventDefault();
    $('#davids-afterpay-popup').removeClass('show');
  });
  
  /* Product Page */
};


theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.currency-input',
    list: '.currency-picker',
    flag: '.currency-flag',
    current: '.currency-picker__current'
  };

  var data = {};

  function init() {
    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    //$(selectors.picker).selectric();

    $primaryPicker = $('#CurrencyPicker-header');
    $secondaryPicker = $('#CurrencyPicker-footer');

    // Keep primary and secondary currency pickers in sync
    if ($secondaryPicker.length) {
      $secondaryPicker.on('change', function() {
        $primaryPicker.val($(this).val());
      });

      $primaryPicker.on('change', function() {
        $secondaryPicker.val($(this).val());
      });
    }



    data = {
      currency: $dataDiv.data('shop-currency'),
      default: $dataDiv.data('default-currency'),
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    //Currency.money_format[data.currency] = data.moneyFormat;
    //Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Fix for customer account page
    $('span.money span.money').each(function() {
      $(this).parents('span.money').removeClass('money');
    });

    // Save current price
    $('span.money').each(function() {
      $(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie();
    theme.responsiveTableWrap();
    
    

    $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);

    $(selectors.flag).on('click',function(e) {
      e.preventDefault();
      newCurrency = $(this).data('currency');
      //Currency.convertAll(Currency.currentCurrency, newCurrency);
      $(selectors.picker + ' option').prop('selected',false);
      $(selectors.picker + ' option[value="'+newCurrency+'"]').prop('selected',true).trigger('change');
      currencyChosenByUser = true;
      Cookies.set('currencyChosenByUser','true',{expires: 10});
      updateCurrencyList(newCurrency);
      killAfterpay(newCurrency);
    });


  }
  
  function killAfterpay(c) {
    if(c != 'USD') {
      $('.db-afterpay').hide();
    } else {
      $('.db-afterpay').show();
    }
  }

  function refresh() {
    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    //console.log(Cookies.get('country'));
    killAfterpay(newCurrency);
    /*
    if(Cookies.get('country') == 'US') {
      console.log('Show Afterpay Again');	  
      setTimeout(function() {
        $('.afterpay-paragraph').show();
      }, 100);
    } else {
      console.log("Don't Show Afterpay Again");
      setTimeout(function() {
        $('.afterpay-paragraph').remove();
      }, 100);
      
    }
    */
    
  }

  function ajaxrefresh() {
    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(data.currency, newCurrency);
    killAfterpay(newCurrency);
  }

  function checkCookie() {
    var cookieCurrency = Currency.cookie.read();
    //var cookieCurrency = null;

    if (cookieCurrency == null) {
      if (data.currency !== data.default) {
        Currency.convertAll(data.currency, data.default);
      }
      else {
        Currency.currentCurrency = data.default;
      }
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    } else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
      Currency.convertAll(data.currency, cookieCurrency);
    } else {
      Currency.convertAll(data.currency, cookieCurrency);
      updateCurrencyList(cookieCurrency);
      currencyChosenByUser = true;
    }
    if(cookieCurrency!=null) {
      //console.log(cookieCurrency);
      killAfterpay(cookieCurrency);
    }
    

  }

  function updateCurrencyList(currency) {
    $(selectors.flag).parent().removeClass('active');
    $(selectors.current).text(currency);
    $(selectors.current + ' span')
    .removeClass()
    .addClass('currency-flag')
    .addClass('currency-flag-'+currency.toLowerCase());
    
    $(selectors.list + ' ' + selectors.flag + '.currency-flag-' + currency.toLowerCase()).parent().addClass('active');
  }

  return {
    init: init,
    refresh: refresh,
    ajaxrefresh: ajaxrefresh
  };
})();

theme.FancySwatches = function () {
  var product = $('.product-container'),
      swatchList = $('#color-select__list'),
      swatchWrapper = $('<div id="color-swatches-search-wrapper"></div>'),
      fullTitle = product.data('full-title').replace("'",""),
      noColorTitle = product.data('title').trim().replace("'",""),
      termHandle = noColorTitle.toLowerCase().replace(/ /g,'-'),
      currentColor = product.data('color').trim(),
      term = $.trim(noColorTitle).toLowerCase().split(' ').join('+'),
      searchURL = '/search?q=' + term + '&type=product&view=colors',
      splitValue = '|';

      if(fullTitle.indexOf(splitValue) > 1) {
        $.getJSON(searchURL, function(data) {
          console.log(data);
          //console.log(data);
          if(data.results_count > 0) {
            $.each(data.results, function(index, item) {
              if(item.title == noColorTitle) {
                if(item.color == currentColor) {
                  var activeClass = 'color-swatch active';
                  if(item.hex) {
                    //console.log(item.hex);
                    $('.variant-select__selected--image').css('background',item.hex);
                    $('.pair-add-bar .color-select__image').css('background',item.hex);
                  } 
                  if(item.image) {
                    //console.log(item.image);
                    $('.variant-select__selected--image').attr('data-bg',item.image).addClass('lazyload').addClass('lazyfade');
                    $('.pair-add-bar .color-select__image').attr('data-bg',item.image).addClass('lazyload').addClass('lazyfade');
                  }
                } else {
                  var activeClass = 'color-swatch';
                }
                if(item.hex) {
                  var swatch = '<div class="variant-select__option '+activeClass+'">' +
                      '<a href="'+item.url+'">' +
                      '<div class="color-select__image" style="background-color:'+item.hex+'"></div>' +
                      '<div class="color-select__label">'+item.color+'</div>' +
                      '</a></div>';
                } else if(item.image) {
                  var swatch = '<div class="variant-select__option '+activeClass+'">' +
                      '<a href="'+item.url+'">' +
                      '<div class="color-select__image lazyload lazyfade" data-bg="'+item.image+'" ></div>' +
                      '<div class="color-select__label">'+item.color+'</div>' +
                      '</a></div>';
                }
                swatchList.append(swatch);
              }
            });
            //console.log(swatchList.children().length);
            if(swatchList.children().length <= 1) {
              $('#color-select__wrap').addClass('hide-list');
            } else {
              $('#color-select__wrap').addClass('show-list');
            }
          }
        });
      }

};



theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  keyboardKeys: {
    TAB: 9
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
    //console.log('wrapTable');
    options.$tables.each(function() {
      //console.log($(this).text());
      $(this).find('td').wrapInner('<span class="responsive-td-content"></span>');
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';
    var focusClass = '';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', 'noopener');
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.variantStyle = $(this.$container).data('variant-style');

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
    //$(this.singleOptionSelector, this.$container).trigger('change


    

    if(this.variantStyle == 'swatch') {
      $(this.singleOptionSelector, this.$container).closest('form').find('.selector-wrapper').hide();
      /*
      $('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
      */
      //console.log('boom swatches');
    }
    //$(this.singleOptionSelector, this.$container).trigger('change');
    //console.log('do the thing');
    this._onSelectChange();

  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
      /*
      var selector = this.originalSelectorId;
      if (variant) {
        var form = $(selector).closest('form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
            form.find('.swatch[data-option-index="' + i + '"] .header .selected').text(radioButton.val());
          }
        }
      }
      */
      // END SWATCHES
      //$(this).is('[data-specs]')
      
      if(variant.featured_image && variant.featured_image.alt && $('.product-template__container').is('[data-has-color-variants]') ) {
      	var variantImageAlt = '.filter-'+variant.featured_image.alt.replace('-','').replace(/\s+/g, '-').toLowerCase() || {};

        var slider = this.$container.find('.slick-slider');
        var colorIndex = slider.find(variantImageAlt).eq(0).index();

        $('#product-slick').slick('slickUnfilter');
        $('#product-slick').slick('slickFilter',variantImageAlt);

      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;



      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      /*
      if(variantImage && variant.image.alt.length) {
      	var variantImageAlt = '.filter-'+variant.featured_image.alt.replace('-','').replace(/\s+/g, '-').toLowerCase() || {};

        var slider = this.$container.find('.slick-slider');
        var colorIndex = slider.find(variantImageAlt).eq(0).index();

        $('#product-slick').slick('slickUnfilter');
        $('#product-slick').slick('slickFilter',variantImageAlt);
        console.log('go to the thing');
      }
      */

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });


    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
      theme.currencySwitcher.ajaxrefresh();
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {

        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
      
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open disable-scrolling',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body'),
      $page: $('#PageContainer'),
      $header: $('.drawer__header'),
      $inner: $('.drawer__inner')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Run function when draw opens if set
    if (
      this.config.beforeDrawerOpen &&
      typeof this.config.beforeDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.beforeDrawerOpen();
      }
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();


    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );

    var h = $('#shopify-section-header').outerHeight();
    if($(this.$drawer).hasClass('drawer--left')) {
		//this.nodes.$inner.css('padding-top',h);
        this.nodes.$inner.css('top',0);
    }
    if($(this.$drawer).hasClass('drawer--right')) {
      h = $(this.$drawer).find('.drawer__header').outerHeight();
      this.nodes.$inner.css('top',h);
      var fh = $(this.$drawer).find('.ajaxcart__footer').outerHeight();
//       $(this.$drawer).find('.ajaxcart__inner--has-fixed-footer').css('top',fh);
    }

    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });



    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    if(this.position == 'left') {
      theme.resetMenu();
    }

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();


/* ================ MODULES ================ */

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    announcementBar: 	'.announcement-bar',
    fullHeader: '#shopify-section-header',
    mainContent: 	'.main-content',
    pageHero: '.collection-hero',
    productPage: '.template-product'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};
  var $headerHeight = $(selectors.fullHeader).outerHeight();

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);

      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });
    setHeaderHeight();
    if ($('body').hasClass('currencies-enabled')) {
    theme.currencySwitcher.init();
    }
    if(!theme.isMobile()) {
    	autoCompleteSearch();
    }
    
    
    
    $('.site-nav__link--main:contains("Sale")').addClass('menu-sale--red');
    $('.site-nav__link--main:contains("SALE")').addClass('menu-sale--red');
    
    $('.drawer-nav__link:contains("Sale")').addClass('menu-sale--red');
    $('.drawer-nav__link:contains("SALE")').addClass('menu-sale--red');

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }
  function setHeaderHeight() {

    $(selectors.announcementBar).css('height',$(selectors.announcementBar).outerHeight()).attr('data-original-height',$(selectors.announcementBar).outerHeight());
    $(selectors.mainContent).css('padding-top',$headerHeight);
    if($('body').hasClass('template-index') && theme.isMobile() == false) {
       //$(selectors.mainContent).css('margin-top','55px');
    }
    if($(selectors.pageHero).length <= 0 && theme.isMobile() == false && $(selectors.productPage).length <=0  ) {
      //$(selectors.mainContent).css('margin-top','55px');
    }
  }

  $(window).on('resize', function(evt) {
      setHeaderHeight();
  });

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  function autoCompleteSearch() {
    // Current Ajax request.
    var currentAjaxRequest = null;
    // Grabbing all search forms on the page, and adding a .search-results list to each.
    var searchForms = $('.search-bar__form').each(function() {
      // Grabbing text input.
      var input = $(this).find('input[name="q"]');
      // Adding a list for showing search results.
      //var offSet = $('#topsearch').position().top + $('#topsearch').innerHeight() + input.position().top + input.innerHeight();
      $('<div class="search-results--full search-results"><div class="search-results__inner flex"></div></div>').appendTo($('.search-bar__form-wrapper'));
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup change', function() {
        // What's the search term?
        var term = $(this).val();
        //console.log(term);
        //console.log(term);
        // What's the search form?
        var form = $(this).closest('.search-bar__form-wrapper');
        // What's the search URL?
        var searchURL = '/search?type=product&q=' + term;
        // What's the search results list?
        var resultsList = form.find('.search-results__inner');
        // If that's a new term and it contains at least 3 characters.
        if (term.length >= 3 && term != $(this).attr('data-old-term')) {
          // Saving old query.
          $(this).attr('data-old-term', term);
          // Killing any Ajax request that's currently being processed.
          if (currentAjaxRequest != null) currentAjaxRequest.abort();
          // Pulling results.
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            // Reset results.
            resultsList.empty();
            // If we have no results.
            if(data.results_count == 0) {
              // resultsList.html('<li><span class="title">No results.</span></li>');
              // resultsList.fadeIn(200);
              resultsList.parent().hide();
            } else {
              // If we have results.
              $.each(data.items, function(index, item) {
                var obj = $('<div class="auto-search__item medium-up--one-third"></div>');
                var link = $('<a></a>').attr('href', item.url);
                obj.append('<div class="thumbnail"><a href="'+item.url+'"><img class="lazyload lazyfade" data-src="' + item.featured_image + '" /></a></div><div class="auto-search__info"></div>');
                //var info = obj.append('<div class="auto-search__info"></div>');
                var info = obj.find('.auto-search__info');
                var title = $('<a class="auto-search__title" href="'+item.url+'">'+item.title+'</a>').appendTo(info);
                //link.text(item.title).appendTo(info);
                //info.append(title.wrap(link));
                if(item.color) {
                  var color = $('<a class="auto-search__color" href="'+item.url+'">'+item.color+'</a>').appendTo(info);
                }
                //var price = item.price;
                var price = theme.Currency.formatMoney(
                  item.price,
                  theme.moneyFormat
                );
                var thePrice = $('<a class="auto-search__price" href="'+item.url+'">'+price+'</a>').appendTo(info);
                //obj.find('.auto-search__info').append();
                //link.wrap('<div class="auto-search__item medium--one-half large-up--one-third"></div>');
                resultsList.append(obj);
              });
              theme.currencySwitcher.ajaxrefresh();
              // The Ajax request will return at the most 10 results.
              // If there are more than 10, let's link to the search results page.
              if(data.results_count > 10) {
                resultsList.append('<div class="one-whole auto-search__view-all"><a class="h3" href="' + searchURL + '">See all results (' + data.results_count + ')</a></div>');
              }
              resultsList.parent().fadeIn();
            }
          });
        }
      });
    });
    // Clicking outside makes the results disappear.
    /*
    $('body').bind('click', function(){
      $('.search-results').hide();
    });
    */
  }



  return {
    init: init,
    unload: unload
  };
})();



theme.Footer = (function() {
  var selectors = {
    body: 'body',
    mainContent: '.main-content',
    footer: '#shopify-section-footer',
    scrollToTop: '#scroll-to-top',
    pageContainer: '#PageContainer'
  };

  var config = {
    parallaxClass: 'site-footer--parallax"'
  };

  var $footerHeight = $(selectors.footer).outerHeight();
  var $footerPadding = parseInt($(selectors.footer).css('margin-top').replace('px',''));

  function init() {
    //console.log('init Footer');
    //$(selectors.pageContainer).css('margin-bottom',$footerHeight+$footerPadding+'px');
    $(selectors.scrollToTop).on('click',function(e) {
      e.preventDefault();
      $('html,body').animate({scrollTop:0}, 500);
    });
    
    if(theme.isMobile()) {
      $('.site-footer .small--accordion h4').on('click',function(e) {

        e.preventDefault();
        $(this).toggleClass('active').next().slideToggle();
      });
    }
  }

  return {
    init: init
  };
})();




theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left', {'beforeDrawerOpen': theme.closeCart});
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {'beforeDrawerOpen': theme.closeNav});
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'beforeDrawerOpen': theme.searchFocus});

};

theme.closeNav = function() {
  theme.initCart();
  theme.LeftDrawer.close();
};
theme.closeCart = function() {
  theme.RightDrawer.close();
  theme.initMobileNav();
};

theme.initCart = function () {
  //Anything to set up?
};

theme.initMobileNav = function() {
  //Anything to set up?
};

/*theme.searchFocus = function () {
  theme.LeftDrawer.close();
  theme.RightDrawer.close();
  //theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  //theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};

theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};
*/

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $('#shopify-section-header').outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        //height: searchHeight + 'px'
        //height: '15vh'
      });
    });
    $('.search-bar__close').on('click',function() {
      $('.search-results--full').remove();
    });
    $(selectors.searchHeaderInput).hover(function() {
      //console.log('boom');
      $(selectors.searchHeader + '.has-text i').addClass('show');
    },function() {
      //console.log('remove z boom');
      $(selectors.searchHeader + '.has-text i').removeClass('show');
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });

  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      //theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    //console.log('close top');
    $(selectors.siteHeaderSearchToggle).focus();
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

/*
(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();
*/

theme.Hero = (function() {

  var hasVideo = false;
  var classes = {
    videoBlock: '.hero--video-block'
  };

  function hero(el) {
    if($(el).find(classes.videoBlock).length) {
      hasVideo = true
    }
  }
  return hero;
})();

theme.HeroSlideshow = (function() {

  var hasVideo = false;
  var classes = {
    videoBlock: '.hero--video-block'
  };

  function heroSlideshow(el) {
    if($(el).find(classes.videoBlock).length) {
      hasVideo = true
    }
    //console.log('booyah');
  }
  return heroSlideshow;
})();



theme.HomeCarousel = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'index-product-carousel__wrapper',
    slideshow: 'index-product-carousel',
    currentSlide: 'slick-current'
  };

  function carousel(el) {
    this.$slideshow = $(el).find('.'+classes.slideshow);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      arrows: true,
      slidesToShow: 4,
      touchThreshold: 20,
      margin: 30,
      prevArrow: '<button type="button" class="slick-prev">'+prevArrow+'</button>',
      nextArrow: '<button type="button" class="slick-next">'+nextArrow+'</button>',
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    };
    if($(window).width() > 600) {
    	this.$slideshow.slick(this.settings);
    }
    this.$slideshow.find('.quick-add-bar').remove();

  }
  return carousel;
})();


theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: true,
      fade: true,
      draggable: true,
      adaptiveHeight: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
      prevArrow: '<button type="button" class="slick-prev">'+prevArrow+'</button>',
      nextArrow: '<button type="button" class="slick-next">'+nextArrow+'</button>'
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();



theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/

theme.cartSticky = function() {
  if(!theme.isMobile()) {
    /*
    $('.cart-sidebar').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 0,
      containerSelector: '#cart-page__form',
      innerWrapperSelector: '.cart-sidebar--sticky'
    });
    */
    //$('.cart-sidebar').stick_in_parent({offset_top: 75});
  }
};


theme.Cart = (function() {

  if(getCookie('last-collection') != '') {
    $('.cart__continue-btn').attr('href',getCookie('last-collection'));
  }
  var selectors = {
    edit: '.js-edit-toggle',
    remove: '.cart__remove',
    update: '.cart__update',
    size: '.single-option-selector'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  
  $(document).on('click','.qty-step-btn',function(z) {
    z.preventDefault();
	var i = parseInt($(this).siblings('.qty-step-count').text()),
        t = $(this).siblings('.qty-step-count'),
    	o = $(this).data('qty-change'),
        r = $(this).closest('.qty-step'),
        e = $(this).closest('.line-item').attr('data-inventory'),
        v = $(this).closest('.line-item').attr('data-variant-id'),
        u = $(this).data('qty-change');
    if(u == 'dec') {
      i--;
    } else {
      if(i < parseInt(v)) {
        i++;
      } 
    }

    if($(this).closest('.thanksgiving-upsell').length) {
      t.text(i);
      return false;
    }
    theme.updateItem(v, i);

  });
  
  function QtySubtract(obj) {
    var qtyInput = $(obj).siblings('.cart__qty-input');
    //console.log(qtyInput.val());
    var current_value = parseInt(qtyInput.val());
    var next_value = current_value - 1;
    //console.log(next_value);
    qtyInput.val(next_value);
    $('.cart__update').trigger('click');
  }
  function QtyAdd(obj) {
    var qtyInput = $(obj).siblings('.cart__qty-input');
    var current_value = parseInt(qtyInput.val());
    var next_value = current_value;
    if(current_value < 9) {
    var next_value = current_value + 1;
    }
    qtyInput.val(next_value);
    $('.cart__update').trigger('click');
  }
  
   $(document).on('click','.line-item--remove-btn',function(e) {
    theme.showSideCartLoader();
    e.preventDefault();
    var i = $(this).attr('data-edit-item');
    //$(this).closest('.line-item').fadeOut();
    theme.removeSideCartItem(i);
  });


  $(document).on('keyup','.cart__qty-input',function(e) {
    e.preventDefault();
    $('.cart-preloader').fadeIn();
    setTimeout(function(){
      $('.cart__update').trigger('click');
    }, 500);
  });

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$remove = $(selectors.remove, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
    //$(document).on('click',this.$remove,this._onRemoveClick.bind(this));

    $(document).on('click',selectors.remove,function(e) {
    	e.preventDefault();
      $('.cart-preloader').fadeIn();

      var $evtTarget = $(e.target);
      var $row = $evtTarget.closest('.cart__row');
      //$row.fadeOut();
      $row.find('.cart__qty-input').val(0);
      //theme.updateCartPage();
      $('.cart__update').trigger('click');
    });

    $(document).on('click',selectors.update,function(e) {
      e.preventDefault();
      theme.updateCartFromForm('cart-page__form');
    });
    
    function QtySubtract(obj) {
      var qtyInput = $(obj).siblings('.cart__qty-input');
      //console.log(qtyInput.val());
      var current_value = parseInt(qtyInput.val());
      var next_value = current_value - 1;
      //console.log(next_value);
      qtyInput.val(next_value);
      $('.cart__update').trigger('click');
      //theme.updateCartPage();
    }
    function QtyAdd(obj) {
      var qtyInput = $(obj).siblings('.cart__qty-input');
      var current_value = parseInt(qtyInput.val());
      var next_value = current_value;
      if(current_value < 9) {
        var next_value = current_value + 1;
      }
      qtyInput.val(next_value);
      //theme.updateCartPage();
      $('.cart__update').trigger('click');
    }

    $(document).on('click','.cart__qty .qty-change', function(e) {
      e.preventDefault();
      $('.cart-preloader').fadeIn();
      if($(this).hasClass('qty-minus')) {
        QtySubtract($(this));
      } else {
        QtyAdd($(this));
      }                 
    });
	
    theme.cartSticky();
 	//var sidebar = new StickySidebar('.cart-sidebar--sticky', {topSpacing: 50});
    
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },
    _onRemoveClick: function(evt) {
      evt.preventDefault();
      var $evtTarget = $(evt.target);
      var $row = $evtTarget.closest('.cart__row');
      $row.fadeOut();
      //console.log($evtTarget.data('id'));

      theme.removeItem(parseInt($evtTarget.data('id')));
      //theme.updateCartPage();
    },
    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();





function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


theme.totalColors = function() {
  var checked = [];
  var found = [];
  $('.product-card').each(function(i,v) {
    var me = $(this),
		myTitle = $.trim(me.find('.grid-view-item__title a').text()),
    	myColor = me.data('colors'),
    	term = $.trim(myTitle).toLowerCase().split(' ').join('+'),
      	searchURL = '/search?q=' + term + '&type=product&view=colors',
        colorCount = 0;
    if(!checked.includes(myTitle)) {
      $.getJSON(searchURL, function(data) {
        colorCount = data.results_count;
        if(colorCount > 1) {
          $('.grid-view-item__title a:contains("'+myTitle+'")')
          .closest('.product-card__info')
          .find('.total-colors a')
          .text(colorCount + ' colors')
          .parent()
          .addClass('show');
        }
        checked.push(myTitle);
      });
    }
  });
};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    //console.log('Collection');

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    theme.CollectionFilters();
    //theme.totalColors();
    
    if($('.inquire-about-rentals__link').length) {
      
    }
    
    
    
    if(theme.isMobile()) {
      /*
      $(".collection-filters--sticky-wrap").stick_in_parent({
        offset_top: 50
      });
      */
      var fgOpen = false;
      $(document).on('click','.filter-group h4 span',function(e) {
        e.preventDefault();
        $(this).closest('.filter-group').siblings('.filter-group').find('.fg').removeClass('is--visible');
        //$('.fg').removeClass('is--visible');
        if($(this).closest('.filter-group').find('.fg').hasClass('is--visible')) {
          $(this).closest('.filter-group').find('.fg').removeClass('is--visible');
          //fgOpen = false;
        } else {
          
          $(this).closest('.filter-group').find('.fg').addClass('is--visible');
          if(fgOpen != false) {
           //$(fgOpen).removeClass('is--visible'); 
          }
          //fgOpen = $(this).closest('.filter-group').find('.fg');
        }

      });
                     
    } else {
      $('.plp-zoom').each(function() {
        var zoomUrl = $(this).data('zoom');
        $(this).zoom({
          url: zoomUrl
        });
        console.log('.plp-zoom');
        
      });
      
      /*
      $(".collection-filters--sticky-wrap").stick_in_parent({
        offset_top: 61
      });
      */
    }
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.CollectionFilters = function() {


  var initialCollectionHTML = false,
      initialCollectionTitle = false;
  
  initialCollectionHTML = $('#Collection').html();
  initialCollectionTitle = document.title;
  


  /* Collection Filtering  */
  var collFilters = $('.coll-filter'),
  	  checkedFilters = $('.coll-filter:checked'),
  	  collectionMain = $('#Collection'),
  	  collectionTitle = collectionMain.data('collection-title'),
  	  collectionHandle = collectionMain.data('collection-handle'),
  	  isFiltered = false,
  	  selectedColor = false,
      originalCache = collectionMain.html();



  function checkFilters() {
    isFiltered = false;
    var filterBy = '';
    $('.filter-group').removeClass('active');
    collFilters.each(function() {
      var f = $(this);
      if(f.is(':checked')) {
      	f.closest('.filter-group').find('.remove').show();
        f.closest('.filter-group').addClass('active');
        isFiltered = true;
        if(filterBy == '') {
          filterBy = '.'+$(this).val();
        } else {
          filterBy = filterBy+'-'+$(this).val();
        }
      }
    });
    if(isFiltered) {

      //$('.grid__item').hide().filter(filterBy).show();
      $('.remove-all').addClass('show');
      //$('.pagination').remove();
      $('body').addClass('is--filtered');
      //console.log(filterBy);

    } else {
      $('.remove-all').removeClass('show');
      $('body').removeClass('is--filtered');
    }
    if($('.grid__item:visible').length) {
      $('.no-matches').hide();
    } else {
      $('.no-matches').show();
    }

    if(theme.dev.showMultipleCurrencies) {
    	//theme.currencySwitcher.ajaxrefresh();
    }
    //theme.totalColors();
  }

  $('.collection-filters .remove-all').on('click',function(e) {
    e.preventDefault();
    $('.filters .coll-filter').prop('checked',false).removeAttr('checked').eq(0).trigger('change');
    $('.filters .remove').hide();
  });

  $('.filter-group .remove').on('click',function(e) {
    e.preventDefault();
    $(this).closest('.filter-group').find('.coll-filter').prop('checked',false).removeAttr('checked').eq(0).trigger('change');
    $(this).hide();
  });

  checkFilters();


  $(document).on('change', '.coll-filter', function() {
    var newTags = [],
    	ajaxhref = '/collections/'+collectionHandle;

    collFilters.each(function(i,v) {
      if($(this).is(':checked')) {
         newTags.push($(this).val());
      }
    });
    if (newTags.length || initialCollectionHTML ) {
      var start = (new Date()).getTime();
      var query = newTags.join('+');
      var hrefForTitle = '/collections/'+collectionHandle+'/'+query
      ajaxhref = hrefForTitle+'?view=infinite-scroll';
      //console.log(ajaxhref);
      $.ajax({
        url: ajaxhref,
        type:'GET',
        beforeSend: function() {
          $('.collection-preloader').fadeIn();
        },
        success: function(data) {
          $('.fg').removeClass('is--visible');
          $('#Collection').html($(data).find('#Collection').html());
          //$('#Collection .collection--wrapper').html($(data).find('#Collection .collection--wrapper').html());
          $('.breadcrumb').html($(data).find('.breadcrumb').html());
          /*
          if($(data).find('#Collection .pagination--wrapper').length) {
            if($('#Collection .pagination--wrapper').length) {
              $('#Collection .pagination--wrapper').html($(data).find('#Collection .pagination--wrapper').html());
            } else {
              $('#Collection').append($(data).find('.pagination--wrapper'));
            }	
          }
          */
          var title = $(data).filter('title').text();
          document.title = title;
          window.history.pushState({url: "" + hrefForTitle + ""}, title, hrefForTitle);
          if(theme.dev.showMultipleCurrencies) {
            setTimeout(function(){ 
				theme.currencySwitcher.ajaxrefresh();
			}, 1000);         	
          }
          checkFilters();
        },
        complete: function() {
          $('.collection-preloader').fadeOut();
          var end = (new Date()).getTime();
   		  //console.log("executed in " + (end - start) + "ms");

        }
      });
    } else {
      $('#Collection').html(initialCollectionHTML);
      document.title = initialCollectionTitle;
      checkFilters(); 
    }
  });
	
  $('.collection--sidebar .accordion h4').on('click',function(e) {
    e.preventDefault();
   	$(this).toggleClass('active').next().slideToggle().toggleClass('active');
  });
  
  $('.filter__toggle').on('click',function(e) {
    e.preventDefault();
    $('.collection--sidebar').toggleClass('is--showing');
  });
  
  if(!theme.isMobile()) {
    if(window.location.href.indexOf('rent') > -1) {
      $('.collection--sidebar h4.rent-header').trigger('click');
    }
    if(window.location.href.indexOf('collections/shop-all') > -1) {
      $('.collection--sidebar h4.buy-header').trigger('click');
    }
  }

  
  setCookie('last-collection',window.location.pathname,10);
};


theme.SidebarMenuSection = (function() {
  function SidebarMenuSection() {
    $('.drawer-nav__toggle').on('click', function() {
      $(this)
        .parent()
        .toggleClass('drawer-nav--expanded')
      	.parent()
      	.closest('ul')
        .toggleClass('drawer-nav--expanded');

      if (
        $(this)
          .parent()
          .hasClass('drawer-nav--expanded')
      ) {
        $(this)
          .children('.drawer-nav__toggle-button')
          .attr('aria-expanded', true);
        $(this)
          .find('.icon-plus')
          .removeClass('icon-plus')
          .addClass('icon-minus');
      } else {
        $(this)
          .children('.drawer-nav__toggle-button')
          .attr('aria-expanded', false);
        $(this)
          .find('.icon-minus')
          .removeClass('icon-minus')
          .addClass('icon-plus');
      }
    });
  }

  return SidebarMenuSection;
})();

theme.SidebarMenuSection.prototype = _.assignIn(
  {},
  theme.SidebarMenuSection.prototype,
  {
    onSelect: function() {
      theme.RightDrawer.close();
      theme.SearchDrawer.close();
      theme.LeftDrawer.open();
    },

    onDeselect: function() {
      theme.LeftDrawer.close();
    }
  }
);

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.Search.init();
    theme.drawersInit();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });


  return Header;
})();

theme.FooterSection = (function() {

  theme.Footer.init();
  function Footer() {
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    onUnload: function() {
      theme.Footer.unload();
    }
  });


  return Footer;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();


theme.Collection = (function() {
  function Collection(container) {
    var $container = (this.$container = $(container));
    
  }
  return Collection;
})();

theme.Product = (function() {
  
  var wistiaVideo = false;

  function Product(container) {
    var $container = (this.$container = $(container,'#quick-view--ProductSection-product-template'));
    var sectionId = $container.attr('data-section-id');
    var qty = 1;
    var wistia_id = $('.product-template__container').attr('data-wistia-id');
    //console.log('product page');
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
	  addToCartFormId: '#AddToCartForm' + '-' + sectionId,
      wistiaID: wistia_id
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.product-single__sku',
      video: 'ProductVideo-'+sectionId,
      productVideo: '.product__video',
      productStatus: '[data-product-status]',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productSlick: '#product-slick',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productQty: '.js-qty',
      productQtyValue: '.js-qty__input',
      productQtyButton: '.js-qty__adjust',
      productQtyPlus: '.js-qty__adjust--plus',
      productQtyMinus: '.js-qty__adjust--minus',
      productThumbsWrapper: '.thumbnails-wrapper',
      productForm: '.product-form',
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      cartContainer: '#CartContainer',
      tabs: '.product-single__tabs',
      tabContent: '.product-single__tab-content',
      tabHeader: '.product-single__tab-header',
      sprBadge: '.spr-badge'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass('js-zoom-enabled');

    this._init();
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
    this._initTabs();
    this._wistiaVideo();
    if($('.product-single__title').text() != 'E-Gift Card') {
    theme.FancySwatches();
    }
    
    
    /*if(theme.isMobile()) {
      $(this.selectors.addToCartText).text(theme.strings.addToCartMobile);
    } else {
      $(this.selectors.addToCartText).text(theme.strings.addToCart);
    }
    */
    
    
    


  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    
    _wistiaVideo: function() {
      window._wq = window._wq || [];
      _wq.push({ id: this.settings.wistiaID, onReady: function(video) {
        $('.wistia-slide-preloader').fadeOut();
        video.play();
      }});
    },

    _init: function() {
     // var theProductSlick = this.selectors.productSlick;
      
      
      $(this.selectors.productSlick)
      	.on('init', function(event, slick, currentSlide){
        	//console.log(slick);
          $(this).attr('data-total-slides',slick.slideCount);
          //$(this).attr('data-visible-slides',slick.)
        })
        .on('reInit',function(event, slick, currentSlide) {
        });
      
      
      $(this.selectors.productSlick).slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        initialSlide: 0,
        mobileFirst: false,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>',
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 0
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0
            }
          }
        ]
      }).fadeIn();
      
      $(this.selectors.productSlick).on('afterChange', function(event, slick, currentSlide){
        //var video = Wistia.api($('.product-template__container').attr('data-wistia-id'));
        
        //$(this).selectors.productSlick(
        window._wq = window._wq || [];
        _wq.push({ id: "_all", onReady: function(video) {
          //console.log("This will run for every video on the page. Right now I'm on this one:", video);
          var allVideos = Wistia.api.all();
          if($('.slick-active .wistia-slide').length) {
            for (var i = 0; i < allVideos.length; i++) {
              if (allVideos[i].hashedId() !== video.hashedId()) {
                allVideos[i].play();
              }
            }
            //video.play();
          } else {
            for (var i = 0; i < allVideos.length; i++) {
              if (allVideos[i].hashedId() !== video.hashedId()) {
                allVideos[i].pause();
              }
            }
            //video.pause();
          }
        }});
      });
      
      $(document).on('click','#product-slick .slick-next.slick-disabled', function(e) {
        e.preventDefault();
        $('#product-slick').slick('slickGoTo',0,true);
        
      });
      $(document).on('click','#product-slick .slick-prev.slick-disabled', function(e) {
        e.preventDefault();
          var gotoSlide = $('#product-slick .slick-slide').length - $('#product-slick .slick-active').length;
          $('#product-slick').slick('slickGoTo',gotoSlide,true);
        
      });
      
      
    
      var form = this.selectors.productForm,
          formID = $(form).attr('id');
      
      $(document).on('click',this.selectors.addToCart+'.ready-to-add',function(e) {
        e.preventDefault();
        theme.addFromAddBar(formID);
      });

      $(document).on('click',this.selectors.sprBadge,function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#shopify-product-reviews").offset().top - $('#shopify-section-header').height()
        }, 500);
      });

      $(this.selectors.productQtyMinus).on('click',function(e) {
        e.preventDefault();
        qty = parseInt($('#quantity').val());
        if(qty > 1) {
          $('#Quantity').val(qty-1);
        } else {
          $('#Quantity').val(1);
        }


      });
      $(this.selectors.productQtyPlus).on('click',function(e) {
        e.preventDefault();
        qty = parseInt($('#Quantity').val());
        $('#Quantity').val(qty+1);
      });
      
      //debugger;
      if($('.psd-left h4:contains(Fabric)').length || $('.psd-left h4:contains(fabric)').length) {
        console.log("psd-left h4 contains fabric");
      } else {
        $('.psd-right ul').eq(0).appendTo('.psd-left').before('<h4>Fabric</h4>');
        var msf = $('.psd-right ul').eq(0);
        $('.psd-right__inner').html('').append(msf).before('<h4>Model Size & Fit <a class="product-single__size-chart-link mfp-inline" href="#fit-guide">size guide</a></h4>');
        $( '.product-single__details ul' ).each(function() {
          if ( '' === $.trim( $( this ).text() ) ) {
            $( this ).remove();
          }
        });
      }
      $('.psd-right__inner h4:contains(Model Size & Fit)').next().addClass('model-size-fit-ul');
      $('<div><a class="product-single__size-chart-link mfp-inline" href="#fit-guide">view size guide</a></div>').insertAfter($('.model-size-fit-ul'));
      //$('#ProductSelect-product-template').trigger('change');
      //$('#fit-guide-popup').load('/pages/fit-guide #shopify-section-fit-guide');
      
      var fabricHeading = $('.psd-left h4:contains(Fabric)');
      fabricHeading.text(fabricHeading.text().replace('Fabric','Details'));
 
      
      
      
      
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initTabs: function() {
      if($(this.selectors.tabs).length) {
        $(this.selectors.tabHeader).on('click',function(e) {
          e.preventDefault();
          var myTab = $(this).attr('href');
          $('.tabs-header a').removeClass('active');
          $('.tab-content').removeClass('active').hide();
          $(this).addClass('active');
          $(myTab).fadeIn().addClass('active');
        });
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      //this._updateAvailability();
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $newImage.find(this.selectors.productFeaturedImage).focus();
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
	  $('.variant-select__wrap').removeClass('is-showing');
      
      // Variations on a theme
      var addText = theme.strings.addToCart;
      if(theme.dev.preorder) {
        addText = theme.strings.preOrder;
      } else {
        if(theme.isMobile()) {
          addText = theme.strings.addToCartMobile;
        } 
      }
      
      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'false');

        if (variant.available) {
          $(this.selectors.addToCartText).text(addText);
          $(this.selectors.addToCart).removeClass('klaviyo-bis-trigger').addClass('ready-to-add');
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).addClass('klaviyo-bis-trigger').removeClass('ready-to-add');
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'true');
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();


theme.initCart = function() {
  /*
    ajaxCart.init({
      moneyFormat: theme.settings.moneyFormat
    });

  if (!theme.cookiesEnabled()) {
    theme.cache.$cartContainer.addClass(theme.cache.cartNoCookies);
    theme.cache.$cartSectionTemplate.addClass(theme.cache.cartNoCookies);
  }*/
};

theme.FAQ = (function() {
  var selectors = {
    question: '.faq__question',
    openClass: 'faq--open'
  }
  function FAQ(container) {
    $(document).on('click',selectors.question,function(e) {
      e.preventDefault();
      $(this).parent().toggleClass(selectors.openClass)
      $(this).next().slideToggle('fast');
    });
  }
  FAQ.prototype = _.assignIn({}, FAQ.prototype, {

  });

  return FAQ;
})();



function sort_name(a, b){
  return ($(b).data('name')) < ($(a).data('name')) ? 1 : -1;
}

theme.OnlineRetailers = (function() {
  var selectors = {
    onlineRetailer: '.online-retailer',
    onlineRetailersWrap: '.online-retailers__wrap'
  }
  function OnlineRetailers(container) {
    $('.online-retailer').sort(sort_name).appendTo('.online-retailers__wrap');
  }
  OnlineRetailers.prototype = _.assignIn({}, OnlineRetailers.prototype, {

  });

  return OnlineRetailers;
})();



theme.Article = (function() {
  var selectors = {
    prevNext: '.article__btn',
    prevBtn: '.article__prev-btn',
    nextBtn: '.article__next-btn',
    articleContent: '.article--inner',
    sectionWrapper: '#MainContent',
    preloader: '.preloader',
    frankiesGirlSelect: '.frankies-girl--dropdown'
  }
  function Article(container) {
    var self = this;
    if($(selectors.frankiesGirlSelect).length) {
      $(document).on('change',selectors.frankiesGirlSelect,function(e) {
        e.preventDefault();
        self._articleAjax($(this).val());
        
      });
    }
    $(document).on('click',selectors.prevNext,function(e) {
      e.preventDefault();
      self._articleAjax($(this).attr('href'));
    });
  }
  Article.prototype = _.assignIn({}, Article.prototype, {
    _articleAjax: function(page) {
      var ajaxhref = page;
      $.ajax({
        url: ajaxhref,
        type:'GET',
        beforeSend: function() {
          $(selectors.preloader).fadeIn();
          $(selectors.articleContent).removeClass('slide-in').addClass('slide-out').addClass('transitioning');
        },
        success: function(data) {
          $(selectors.articleContent).removeClass('slide-out');
          $(selectors.articleContent).html($(data).find(selectors.articleContent).html());

          var title = $(data).filter('title').text();
          document.title = title;
          window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);


          if($(data).find('.article__prev-btn').attr('href') != '') {
            $(selectors.prevBtn).html($(data).find(selectors.prevBtn).html());
            $(selectors.prevBtn).attr('href',$(data).find(selectors.prevBtn).attr('href')).fadeIn();
            
          } else {
            $(selectors.prevBtn).fadeOut();
          }
          if($(data).find('.article__next-btn').attr('href') != '') {
            $(selectors.nextBtn).html($(data).find(selectors.nextBtn).html());
            $(selectors.nextBtn).attr('href',$(data).find(selectors.nextBtn).attr('href')).fadeIn();
            
          } else {
            $(selectors.nextBtn).fadeOut();
          }

        },
        complete: function() {
          $(selectors.articleContent).addClass('slide-in');
          $(selectors.preloader).fadeOut('slow',function() {
            $(selectors.articleContent).removeClass('transitioning').removeClass('slide-in');
          });
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      });
    }

  });

  return Article;
})();


theme.NewsletterPopup = (function() {
  var popupWrapper = '#newsletter-popup-wrapper',
  	  popupDelay = parseInt($(popupWrapper).data('newsletter-popup-delay')) * 1000,
      popupExpiration = parseInt($(popupWrapper).data('newsletter-popup-expiration'));

  
  function NewsletterPopup(container) {
    //showThePopup();
    //console.log(window.location.href);

    if(getCookie('newsletter') == 'hide') {
      return;
    }
    if($('#newsletter-popup-wrapper').data('show-newsletter-popup') != true) {
      return;
    }
    
    //setTimeout(showThePopup,popupDelay);
    showThePopup();
    
  }
  function setTheCookie() {
    setCookie('newsletter','hide', {expires: popupExpiration});
  }
  function showThePopup() {
    $.magnificPopup.open({
      items: {
        src: '#newsletter-popup'
      },
      removalDelay: 500,
      showCloseBtn: true,
      closeBtnInside: true,
      mainClass: 'mfp-with-zoom',
      type: 'inline'
    });
    setTheCookie();
  }
  NewsletterPopup.prototype = _.assignIn({}, NewsletterPopup.prototype, {
    onLoad: function() {
      //console.log('load');
    },
    onSelect: function() {
      showThePopup();
    }
  });
  return NewsletterPopup;
})();

/*

theme.HelperSection = (function() {
  function HelperSection() {
    //theme.Header.init();
    //theme.Search.init();
    //theme.drawersInit();
  }

  HelperSection.prototype = _.assignIn({}, HelperSection.prototype, {
    onUnload: function() {
      theme.HelperSection.unload();
    }
  });


  return HelperSection;
})();

*/

theme.PressPage = function() {
  if($('#shopify-section-press-template').length) {
    var pressGrid = $('.press-grid').masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.press-grid__item',
      // use element for option
      columnWidth: '.press-grid__sizer',
      percentPosition: true,
      gutter: 60,
      stagger: 30
    });
    var moreBtn = '.press--load-more';
    $(document).on('click', moreBtn, function(e) {
      e.preventDefault();
      var ajaxhref = $(this).attr('href');
      //$('.pagination').remove();
      $(moreBtn).fadeOut();
      $.get(ajaxhref, function(data) {
        var newPressItems = $(data).find('.press-grid__item');
        var newPagination = $(data).find(moreBtn);
        $('.press-grid').append(newPressItems).masonry('appended', newPressItems);
        if(newPagination.length) {
          $(moreBtn).attr('href',newPagination.attr('href')).fadeIn();
		} else {
          //console.log('no mas pages');
       	  $(moreBtn).hide().remove();	    
        }
      }).done(function() {
		
      });
      
    });
  }
};

theme.Lookbook = function() {
  if($('.lookbook-slider').length) {
    $('.lookbook-slider').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      cssEase: 'linear'
    });
  }
};

$.fn.masonryImagesReveal = function( $items ) {
  var msnry = this.data('masonry');
  var itemSelector = msnry.options.itemSelector;
  // hide by default
  $items.hide();
  // append to container
  this.append( $items );
  $items.imagesLoaded().progress( function( imgLoad, image ) {
    // get item
    // image is imagesLoaded class, not <img>, <img> is image.img
    var $item = $( image.img ).parents( '.press-grid__item' );
    // un-hide item
    $item.fadeIn();
    // masonry does its thing
    msnry.appended( $item );
  });
  return this;
};


/*
theme.FAQ = (function() {
  var selectors = {
    question: '.faq__question',
    openClass: 'faq--open'
  }
  function FAQ(container) {
    $(document).on('click',selectors.question,function(e) {
      e.preventDefault();
      $(this).parent().toggleClass(selectors.openClass)
      $(this).next().slideToggle('fast');
    });
  }
  FAQ.prototype = _.assignIn({}, FAQ.prototype, {

  });

  return FAQ;
})();
*/

theme.dbAjaxForm = function() {
  /*
  $('#db-ajax-form-name').val("David Bowick");
  $('#db-ajax-form-email').val("david@abbyrosedesign.com");
  $('#db-ajax-form-phone').val("404-433-1152");
  $('#db-ajax-form-message').val("Testing a message you see");
  */
  var selectors = {
    formId: '#db-ajax-contact-form',
    messages: '#db-ajax-form-messages'
  }
  var responses = {
    success: "Thank You! Your message has been sent.",
    error: "Uh oh! Something has gone terribly wrong."
  }
  $(selectors.formId).submit(function(event) {
    event.preventDefault();
    var formData = $(selectors.formId).serialize();
    $.ajax({
      type:'POST',
      url: $(selectors.formId).attr('action'),
      data: formData
    })
    .done(function(response) {
      //$(selectors.formId).hide();
      $(selectors.messages).removeClass('error');
      $(selectors.messages).addClass('success');

      // Set the message text.
      $(selectors.messages).text(responses.success);

      // Clear the form.
      $('.db-input').val('');
    })
    .fail(function(data) {
      // Make sure that the formMessages div has the 'error' class.
      $(selectors.messages).removeClass('success');
      $(selectors.messages).addClass('error');

      $(selectors.messages).text(responses.success);
    });
  });
};


theme.Stockists = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var selectors = {
    link: '.stockist-link',
    tab: '.stockist-tab'
  }
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };
  function Stockists(container) {
    //console.log('stockists rule!');

    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var spreadsheetID = $container.data('spreadsheet-id');

      function toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      }

      $(selectors.link).on('click',function(e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        $(selectors.link).removeClass('active');
        $(selectors.tab).removeClass('active').hide();

        $(this).addClass('active');
        target.addClass('active').fadeIn();
      });

      //console.log(container);

      GetStockists('1','domestic');

      function GetStockists(worksheet,location) {

        var url = "//spreadsheets.google.com/feeds/list/" + spreadsheetID + "/"+worksheet+"/public/values?alt=json"; //this is the part that's changed
		var innerSelector = '#'+location+'-inner',
            innerSelect = null;
        if(location == 'domestic') {
          innerSelect = '#state-picker';
        } else if(location == 'international') {
          innerSelect = '#country-picker';
        } else if(location == 'online') {
        }

        var addresses = [],
        	states = [],
          	cities = [];

        $.getJSON(url, function(data) {
          //console.log(data);
          var entry = data.feed.entry;
          $(entry).each(function(){
            var website = false,
                name = false,
                address = false,
                city = false,
                state = null,
                stateHandle = false,
                zip = false,
                phone = false,
                country = false,
                countryHandle = false,
                region = false,
                cityHandle = false,
                simple_address = false;

            if(this.gsx$name) {
              name = toTitleCase(this.gsx$name.$t);
            }

            if(this.gsx$addr1) {
              address = toTitleCase(this.gsx$addr1.$t);
              simple_address = address;
              address = address.replace(/(?:\r\n|\r|\n)/g, '<br />');
            }


            if(this.gsx$city) {
              city = toTitleCase(this.gsx$city.$t);
              cityHandle = slugify(city);
            }


            if(this.gsx$website)
              website = this.gsx$website.$t;


            if(this.gsx$state) {
              state = this.gsx$state.$t.toUpperCase();
              stateHandle = state.replace(/\s+/g, '-').toLowerCase();
            }

            if(this.gsx$zip) {
              zip = this.gsx$zip.$t;
            }

            if(this.gsx$region)
              region = this.gsx$region.$t;

            if(this.gsx$country) {
              country = this.gsx$country.$t;
              countryHandle = country.replace(/\s+/g, '-').toLowerCase();
            }

            if(this.gsx$phone) {
              phone = this.gsx$phone.$t;
            }

            if(location == 'international') {
              if(this.gsx$region) {
                state = this.gsx$region.$t;
                stateHandle = slugify(state);
              }

              city = this.gsx$country.$t;
              cityHandle = slugify(city);
            }

            if(location == 'domestic' || location == 'international') {
              var cityDivId = '#'+cityHandle;
              var mapsLink = "<a target='_blank' href='http://maps.google.com/?q=" + simple_address +"'>"+ address +"<br/></a>";
              var entrydiv = "<div class='stockist dontsplit' data-state='"+state+"' data-country='"+country+"' data-city='"+city+"' data-name='"+$.trim(name.replace('The',''))+"'>";
              if(website) {
                entrydiv += "<a class='name' href='"+website+"'>" + name + "</a>";
              } else {
                entrydiv += name + '<br/>';
              }
              entrydiv +=  address + '<br/>';

              if(phone) {
                entrydiv += phone;
              }
              entrydiv += "</div>";

              if(!addresses.includes(address)) {
                addresses.push(address);
                var st = '#'+stateHandle;
                if(!states.includes(state)) {
                  states.push(state);
                  $('#'+location+'-inner').append('<div id="'+stateHandle+'" class="state"><h3>'+state+'</h3><div class="state-entries"></div></div>');
                }
                if(!cities.includes(city)) {
                  cities.push(city);
                  var cityDiv = "<div id='"+cityHandle+"' class='city-div'><h5 class='brown'>"+city+"</h5><div class='city-inner flex'></div></div>";
                  $(st).find('.state-entries').append(cityDiv);
                }
                $('#'+cityHandle).find('.city-inner').append(entrydiv);
              }

              $(innerSelector + ' .state').sort(sort_id).appendTo(innerSelector);

              $(innerSelector + ' .city-div').each(function(i,v) {
                var me = $(this);
                var inner = $(this).find('.city-inner');
                me.find('.stockist').sort(sort_name).appendTo(inner);
                var myStores = me.find('.stockist');
              });

            } // if location == 'domestic' || location == 'international'

            if(location == 'online') {
              var entryDiv = "<div class='stockist online'><h4>"+name+"</h4><a href='"+website+"'>"+website+"</a></div>";
              $(innerSelector).append(entryDiv);
            }
          });

          $(innerSelector + ' .state').each(function(i,v) {
            $(innerSelect).append("<option value='"+$(this).attr('id')+"'>"+$(this).find('h3').text()+"</option>");
            var me = $(this);
            me.find('.city-div').sort(sort_id).appendTo(me);
          });

          $('.preloader').fadeOut();

          if(location == 'domestic') {
            $('#domestic-inner').fadeIn();
            GetStockists('2','international');
          } else if(location == 'international') {
            $(innerSelector).parent().hide();
            GetStockists('3','online');
          } else if (location == 'online') {
            $(innerSelector).parent().hide();
            return false;
          }
        });




        $('#state-picker,#country-picker').on('change',function() {
          //console.log($(this).val());
          var myTab = $(this).closest('.stockist-tab');
          if($(this).val() == 'all') {
            myTab.find('.state').fadeIn();
          } else {
            myTab.find('.state').hide();
            myTab.find('#'+$(this).val()).fadeIn();
            $(window).resize();
          }
        });


      }
    //}
  }

  Stockists.prototype = _.assignIn({}, Stockists.prototype, {
    onUnload: function() {
      theme.Stockists.unload();
    },
    onBlockSelect: function(evt) {
      //console.log('boo');
    }

  });

  return Stockists;
})();


theme.Quotes = (function() {

  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    //console.log('Quotes');
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


var sections = new theme.Sections();

$(document).ready(function() {


  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('map', theme.Maps);
  sections.register('hero',theme.Hero);
  sections.register('hero-slideshow',theme.HeroSlideshow);
  sections.register('home-carousel',theme.HomeCarousel);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('page-faq', theme.FAQ);
  sections.register('page-stockists',theme.Stockists);
  sections.register('newsletter-popup',theme.NewsletterPopup);
  sections.register('article-template',theme.Article);
  sections.register('page-online-retailers', theme.OnlineRetailers);

});

function Utils() {

}

Utils.prototype = {
  constructor: Utils,
  isElementInView: function (element, fullyInView) {
    var offset = 100;
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height() ;

    if (fullyInView === true) {
      return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {
      return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
  }
};

var Utils = new Utils();




/*
var allWistiaPaused = false;

theme.pauseAllWistia = function() {
  window._wq = window._wq || [];
  _wq.push({ id: "_all", onReady: function(video) {
    video.pause();
    allWistiaPaused = true;
  }});
};
theme.playAllWistia = function() {
  window._wq = window._wq || [];
  _wq.push({ id: "_all", onReady: function(video) {
    if(allWistiaPaused) {
    	video.play();
      	allWistiaPaused = false;
    }
  }});
};
*/

theme.collapsingHeader = function() {
  
  var headerElement = '#shopify-section-header',
 	  collapseAfter = $(headerElement).outerHeight();
  
  if(theme.dev.showAnnouncementBar) {
  	$(headerElement).css('top','0px');    
  }
  // If we're above the scroll minimum
  if ($(window).scrollTop() > collapseAfter || $(window).scrollTop() > collapseAfter) {
    $(headerElement).addClass('is-collapsed');
    ///$('.ju_Con').slideUp();
    //$(headerElement).css('top','0px');

    if(theme.dev.showAnnouncementBar) {
      $(headerElement).css('top','0px');    
    }



    //If not
  } else {
    //$('.ju_Con').slideDown();
    //$(headerElement).css('top','35px');
    
    if(!$('body').hasClass('js-drawer-open-left')) {
    	$(headerElement).removeClass('is-collapsed');
    }
    if(!theme.isMobile()) {
      $(headerElement).removeClass('is-collapsed');
     
    }
  }
  
  if($(window).scrollTop() < 10 && !theme.isMobile()) {
    // Just to be sure it all comes back
    $(headerElement).removeClass('is-collapsed');
  }
     
};


var isPaged = false;

theme.infiniteScroll = function() {
  var hasPagination = false;
  
  $('.product').each(function() {
    var st = $(this).scrollTop();
    $(this).css({
        'opacity' : 1 - st/600
    });
    /*
    var outerHeight = $(this).outerHeight();
    var scrollPercent = (outerHeight - window.scrollY) / outerHeight;
    if(scrollPercent >= 0){
      $(this).css('opacity', scrollPercent);
    }
    */
  });
  
  if($('.pagination--wrapper').length) {
    $('.pagination--wrapper').show();
    var ajaxhref = false,
        productGrid = '.products',
        wrapper = '#Collection',
    	isElementInView = Utils.isElementInView($('.next-page-preloader'), false);

    var ajaxhref = $('.next-page-preloader').attr('data-paginate-next-url');
    
    if(isPaged == false && isElementInView) {
      isPaged = true;

      //console.log("Next page is " + $('.next-page-preloader').data('paginate-next-url'));
      //$('.next-page-preloader').remove();
      $.get(ajaxhref, function(data) {
        var newCollection = $(data).find(productGrid).html();
        if($(data).find('.pagination--wrapper').length) {
          var newPagination = $(data).find('.pagination--wrapper').html();
          var hasNewPagination = true;
        }
        $(productGrid).append(newCollection);
        //console.log(newPagination);
        if(hasNewPagination) {   
          $('.pagination--wrapper').html(newPagination);
        } else {
          $('.pagination--wrapper').remove();
        }


      }).done(function() {
        if(theme.dev.showMultipleCurrencies) {
          theme.currencySwitcher.ajaxrefresh();
        }
        theme.totalColors();
        isPaged = false;
      });
    }

  } else {
    $('.pagination--wrapper').remove();
  }
};

theme.pauseUnseenVideos = function() {
  //console.log('pauseVimeos');
  var vimeos = $('iframe[src*="vimeo.com"]');
  if(vimeos.length) {
    vimeos.each(function(i,v) {
      var isElementInView = Utils.isElementInView($(v), false);
      var player = new Vimeo.Player(v);
      var playerIsPaused = true;
      if(isElementInView && playerIsPaused) {
        player.play()
        playerIsPaused = false;
      } else {
        playerIsPaused = true;
        player.pause();
      }
    });
  }
  
  if($('#ProductSection-product-template').data('wistia-id') !== 'undefined') {
    var wistiaVid = $('#ProductSection-product-template').data('wistia-id');
    window._wq = window._wq || [];
    _wq.push({ id: wistiaVid, onReady: function(video) {
      var isElementInView = Utils.isElementInView($('#product-slick'),false);
      if(isElementInView) {
        video.play();
      } else {
        video.pause();
      }
    }});
  }
  
};

function simpleParallax(intensity, element) {
  $(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    var imgPos = scrollTop / intensity + 'px';
    element.css('transform', 'translateY(' + imgPos + ')');
  });
};



theme.windowScrolling = function() {
  var scrollTimeout;
  var throttle_amount = 200;
  $(window).scroll($.throttle( throttle_amount, function() {
    theme.collapsingHeader();
    theme.infiniteScroll();
    theme.pauseUnseenVideos();
  }) );
};





theme.productHovers = function() {
  var $product = $('.product'),
      timer = 1;

    $(document).on('mouseenter','.product', function() {
      $(this).find('.grid-view-item__image-hover').addClass('lazyload');
    });


};



theme.cookiesPopup = function() {
  
  var showCookieNotice = false;
  var cookiesPopup = '.cookies-popup';

  if(Cookies.get('cookie-popup') != 'checked') {
    showCookieNotice = true;
    $(cookiesPopup).show();
  }
  
  //console.log(showCookieNotice);
  $('.cookies-popup--close,.cookies-popup .btn--primary').on('click',function(e) {
    e.preventDefault();
    Cookies.set('cookie-popup','checked',{expires: 365});
    $(cookiesPopup).fadeOut();
  });

};

theme.SearchFilters = function() {
  var selectors = {
    product: '.template-search .product',
    filterElem: '.coll-filter',
    filterWrapper: '.search-filters--wrapper',
    colorFilter: '#color-filter',
    sizeFilter: '#size-filter'
  };
  var colors = [],
      sizes = [],
      searchTerms = $('#SearchInput').val();

  $(selectors.product).each(function(i,v) {
    var myColors = $(this).data('colors').split(',');
    $.each(myColors,function(ci,cv) {
      var colorHandle = cv.replace(/ /g, '-').toLowerCase();
      if($.inArray(colorHandle,colors) < 0) {
        colors.push(colorHandle);
      }
    });
    var mySizes = $(this).data('sizes').split(',');
    $.each(mySizes,function(ci,cv) {
      var sizeHandle = cv.replace(/ /g, '-').toLowerCase();
      if($.inArray(sizeHandle,colors) < 0) {
        sizes.push(sizeHandle);
      }
    });
  });

  $(selectors.filterElem).each(function(i,v) {
    $(this).parent().hide();
    var valueHandle = $(this).val().replace(/ /g, '-').toLowerCase();
    if($.inArray(valueHandle,colors) >= 0 || $.inArray(valueHandle,sizes) >= 0) {
      $(this).parent().show();
    }
  });

  $(selectors.colorFilter + ' ' + selectors.filterElem).on('click',function(e) {
    //e.preventDefault();
    var color = $(this).data('color');
    $(selectors.product).parent().hide();
    $(selectors.product + '[data-colors*="' + color + '"]').parent().show();
    $('.remove-all').addClass('show');
    $(this).closest('.filter-group').find('.remove').show();
  });
  
  $(selectors.sizeFilter + ' ' + selectors.filterElem).on('click',function(e) {
    //e.preventDefault();

    var size = $(this).data('size');
    $(selectors.product).parent().hide();
    $(selectors.product + '[data-sizes*="' + size + '"]').parent().show();
    $('.remove-all').addClass('show');
    $(this).closest('.filter-group').find('.remove').show();
  });
  
  
  

  $(selectors.filterWrapper + ' .remove-all').on('click',function(e) {
    e.preventDefault();
    $(selectors.product).parent().show();
    $(this).removeClass('show');
    $(selectors.filterWrapper).find('.remove').hide();
    $(selectors.filterWrapper).find(selectors.filterElem).prop('checked',false);
  });

  $(selectors.filterWrapper + ' .remove').on('click',function() {
    $(this).closest('.filter-group').find(selectors.filterElem).prop('checked',false);
    $(this).hide();
    if($(selectors.filterElem+':checked').length <= 0) {
      $(selectors.filterWrapper + ' .remove-all').removeClass('show');
      $(selectors.product).parent().show();
    }
  });




};


theme.afterCartLoad = function () {
  theme.cache.$cartContainer.on('ajaxCart.afterCartLoad', function(evt, cart) {
    theme.RightDrawer.open();

    // set cart bubble after ajax cart update
    if (cart.item_count > 0) {
      theme.cache.$siteHeaderCart.addClass('cart-bubble--visible');
    } else {
      theme.cache.$siteHeaderCart.removeClass('cart-bubble--visible');
    }

    // Size the cart's fixed footer
    theme.sizeCartDrawerFooter();
  });

  theme.cache.$cartContainer.on('ajaxCart.updatingQty', function() {
    $('.cart__checkout').addClass('btn--ajax-disabled');
  });
};

theme.init = function() {
 // console.log('theme.init');
  theme.dbAjaxForm();
  theme.removeCookies();
  theme.customerTemplates.init();
  theme.drawersInit();
  theme.windowScrolling();
  //theme.cookiesPopup();
  if($('body').hasClass('template-search')) {
    theme.SearchFilters();
  }
  theme.PressPage();
  theme.Lookbook();
  //window.GRJQLoaded(jQuery);

  //theme.itsSelectric();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)')
  });

  /*
  $('.drawer-nav__has-sublist .drawer-nav__link').on('click',function(e) {
    e.preventDefault();
    $(this).parent().parent().toggleClass('drawer-nav--expanded');
  });
  */
  /*
  var currentMenuLevel = 1;
  var activeSubList = false;
  $('.drawer-nav__has-sublist .drawer-nav__link').on('click',function(e) {
    e.preventDefault();
    var myLvl = $(this).closest('.drawer-nav__item').data('menu-level');
    currentMenuLevel = myLvl;
    $('.drawer__back-button').fadeIn();
    $('.drawer-nav__sublist').removeClass('is--active');
    $('.drawer-nav__item-level-'+myLvl).addClass('slide-out');
    activeSubList = $(this).closest('.drawer-nav__item').find('.drawer-nav__sublist');
    //.addClass('is--active');
    $(this).closest('.drawer-nav__item').find('.drawer-nav__sublist').addClass('is--active');
    $(this).parent().parent().toggleClass('drawer-nav--expanded').parent().toggleClass('drawer-ul--expanded');
  });
  

  
  $('.drawer-nav__return-btn').on('click',function(e) {
    e.preventDefault();
    var myLvl = parseInt($(this).closest('.drawer-nav__item').data('menu-level'));
    currentMenuLevel = myLvl;
    $('.drawer-nav__sublist').removeClass('is--active');
    $('.drawer-nav__item-level-'+myLvl).removeClass('slide-out');
    $(this).closest('.drawer-nav__item').removeClass('drawer-nav--expanded');
    activeSubList = $(this).closest('.drawer-nav__item').parent().closest('.drawer-nav__item').find('.drawer-nav__sublist');
    if(currentMenuLevel == 1) {
      $('.drawer__back-button').fadeOut();
    }
  });
  
  $('.drawer__back-button').on('click',function(e) {
    e.preventDefault();
    activeSubList.find('.drawer-nav__return-btn').trigger('click');
  });
  */
  var previousPanel = false;
  var activePanel = false;
  
  
  $('.drawer-nav__has-sublist .drawer-nav__link').on('click',function(e) {
    e.preventDefault();
    
    var myPanel = '#menu-panel-'+$(this).data('menu-panel');
    theme.showMenuPanel(myPanel);
  });
  
  
  $('.drawer__back-button').on('click',function(e) {
    e.preventDefault();
    var returnTo = '#menu-panel-'+$('.menu-panel.is--visible').data('return-panel');
    theme.showMenuPanel(returnTo);
    //$('.menu-panel').removeClass('is--visible');
    //$(returnTo).addClass('is--visible');
    
  });
  
  


  enquire.register(config.mediaQuerySmall, {
    match: function() {
      //initSlider($slider, mobileOptions);

      $('.mobile-accordion').on('click',function(e) {
        e.preventDefault();
        $(this).toggleClass('show').next().slideToggle();
      });
    }
  });

  enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      theme.productHovers();
    }
  });

  $(document).on('click','.has-sub',function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next().slideToggle();
  });
  
  
  /*$('.product-single').on('click',function(e) {
    $('.variant-select__wrap').removeClass('is-showing');
  });
  */
  
  /*
  $(document).on('click','.variant-select__wrap',function(e) {
    //e.stopPropagation();
  });
  */
  /*
  $(document).on('click','.variant-select__wrap:not(.is-showing) .variant-select__selected',function(e) {
    e.preventDefault();
    var wrap = $(this).closest('.variant-select__wrap');
    console.log("!hasClass is-showing, so add it");
    wrap.addClass('is-showing');
    
    
    //$(this).closest('.variant-select__wrap').addClass('is-showing');
  });
  
  $(document).on('click','.variant-select__wrap.is-showing .variant-select__selected',function(e) {
    e.preventDefault();
    var wrap = $(this).closest('.variant-select__wrap');
    wrap.removeClass('is-showing');
    
    //$(this).closest('.variant-select__wrap').addClass('is-showing');
  });
  */
  
  
  $(document).on('click','.variant-select__selected',function(e) {
    e.preventDefault();
    var obj = $(this).closest('.variant-select__wrap');
    obj.toggleClass('is-showing');    
    
    if(obj.attr('id') == 'color-select__wrap') {
      //I'm a color list
      $('.variant-select__wrap.size').removeClass('is-showing');
    } else {
      //I'm not a color list
      $('#color-select__wrap').removeClass('is-showing');
    }
    
    
  });
  
  
  
  $('.product-form-product-template .single-option-selector').each(function(i,v) {
    var s = $(this);
    var sId = 'sos-' + s.attr('id');
    var l = $('<div class="variant-select__list"></div>');
    var f = $(this).find('option:selected').val();
    s.parent().append('<div class="variant-select__wrap '+s.data('option-name').toLowerCase()+'" id="'+sId+'" name=""></div>');
    var u = $('#'+sId);
    u.append('<div class="variant-select__selected">'+f+'</div>');
    u.append(l);
    s.find('option').each(function() {
      l.append('<div class="variant-select__option"><div class="variant-select__option-label" data-value="' + $(this).val() + '">'+$(this).text()+'</div></div>');
    });
    s.hide();
    if(s.data('option-name') != 'Size') {
      s.closest('.selector-wrapper').hide();
    }
    s.closest('.selector-wrapper').find('.variant-select__option-label.available').eq(0).trigger('click');
  });
  
  $('.pair-add-bar .single-option-selector').each(function(i,v) {
    var s = $(this);
    var sId = 'sos-'+s.attr('id');
    var l = $('<div class="variant-select__list"></div>');
    var f = $(this).find('option:selected').val();
    s.parent().append('<div class="variant-select__wrap '+s.data('option-name').toLowerCase()+'" id="'+sId+'" name=""></div>');
    var u = $('#'+sId);
    u.append('<div class="variant-select__selected">'+f+'</div>');
    u.append(l);
    s.find('option').each(function() {
      l.append('<div class="variant-select__option"><div class="variant-select__option-label" data-value="' + $(this).val() + '">'+$(this).text()+'</div></div>');
    });
    s.hide();
    if(s.data('option-name') != 'Size') {
      s.closest('.selector-wrapper').hide();
    }
    s.closest('.selector-wrapper').find('.variant-select__option-label.available').eq(0).trigger('click');
  });
  
  
  $('.product-form-product-template .selector-wrapper .variant-select__option-label').on('click',function(e) {
    e.preventDefault();
    var myVal = $(this).text();
    var w = $(this).closest('.variant-select__wrap');
    var s = '#'+w.attr('id').replace('sos-','');
	w.find('.variant-select__selected').text(myVal);
    $(s).val(myVal).trigger('change');
  });
  
  $('.pair-add-bar .selector-wrapper .variant-select__option-label').on('click',function(e) {
    e.preventDefault();
    var myVal = $(this).text();
    var w = $(this).closest('.variant-select__wrap');
    var s = '#'+w.attr('id').replace('sos-','');
    //console.log(s);
	w.find('.variant-select__selected').text(myVal);
    $(s).val(myVal).trigger('change');
  });
  
  $(document).on('change','.quick-add-bar input',function(e) {
    e.preventDefault();
    var f = $(this).closest('.quick-add-bar');
    var c = f.find('input:checked');
    var vs = false;
    var s = f.find('select');
    var o = f.find('select option');
    var selected_variant = s.val();
    c.each(function(i,v) {
      if(!vs) {
        vs = $(v).val();
      } else {
        vs += ' / ' + $(v).val();
      }
    });
    o.each(function() {
      var t = $.trim($(this).text());
      if(t == vs) {
        $(this).attr('selected', 'selected').prop('selected',true);  
        selected_variant = $(this).val();
      }
    });
    theme.addItem(selected_variant,1);
    if(theme.onCartPage()) {
      $('.cart-preloader').fadeIn();
    }
    
  });
  
  $(document).on('click','.quick-add-button', function(e) {
    e.preventDefault();
    var selected_variant = $(this).data('variant-id');
    theme.addItem(selected_variant,1);
  });
  
  $(document).on('click','.thanksgiving__add-btn',function() {
    var selected_variant = $(this).data('variant-id');
    theme.addItem(selected_variant,1);
    return false;
  });
  
  $(document).on('click','.thanksgiving-upsell__add',function() {
    var selected_variant = $(this).data('variant-id');
    var qty = parseFloat($(this).closest('.thanksgiving-upsell').find('.qty-step-count').text());
    theme.addItem(selected_variant,qty);
    return false;
  });
  
  var getCookieFunction = function(c_name) {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1)
      c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1)
      return null;
    c_start = c_value.indexOf("=", c_start) + 1;
    var c_end = c_value.indexOf(";", c_start);
    if (c_end == -1)
      c_end = c_value.length;
    return unescape(c_value.substring(c_start,c_end));
  };
  var clearCookieFunction = function(c_name) {
    document.cookie = c_name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  var sessionId = getCookieFunction("giftreggie_session_cookie");
  
  if(theme.dev.registryEnabled && sessionId) {
    $('.quick-registry-button').show();
    $('.gift-reggie-button').show();
  } else {
    $('.quick-registry-button').hide();
    $('.gift-reggie-button').hide();
  }
  
  $(document).on('click','.quick-registry-button', function(e) {
    e.preventDefault();
    var variantId = $(this).data('variant-id');
    var addUrl = '/apps/giftregistry/registry/'+theme.dev.registryId+'/add?sid=' + encodeURIComponent(sessionId);
    $('.collection-preloader').fadeIn();
    $.ajax({
      url: addUrl,
      data: { id: variantId, quantity: 1 },
      method: 'POST'
    }).done(function(msg) {
      //console.log(msg);
      window.location.href = '/apps/giftregistry/registry/'+theme.dev.registryId;
    }).fail(function(jqXHR,textStatus) {
      console.log(jqXHR,textStatus);
    });;
  });
  
  

  $(document).on('change','.pair-add-bar .single-option-selector',function(e) {
    //console.log('change!!!!!');
    e.preventDefault();
    var f = $(this).closest('.pair-add-bar');
    var c = f.find('.single-option-selector');
    var vs = false;
    var s = f.find('.pair-select');
    var o = f.find('.pair-select option');
    var selected_variant = s.val();
    c.each(function(i,v) {
        //console.log($(v).val());
      if(!vs) {
        vs = $(v).val();
      } else {
        vs += ' / ' + $(v).val();
      }
    });
    o.each(function() {
      var t = $.trim($(this).text());
      if(t == vs) {
        $(this).attr('selected', 'selected').prop('selected',true);  
        selected_variant = $(this).val();
      }
    });
    //console.log(selected_variant);
    //theme.addItem(selected_variant,1);
    $('.pair-add-bar .product-form__cart-submit').attr('data-variant',selected_variant);
  });
  
  $('.pair-add-bar .product-form__cart-submit').on('click',function(e) {
    e.preventDefault();
    var selected_pair = $(this).data('variant');
    theme.addItem(selected_pair,1);
  });
  
  //Be sure something is selected on load
  $('.product-form-product-template  .selector-wrapper:visible .variant-select__selected').each(function(i,v) {
    var myVal = $(v).text();
    $('.product-form-product-template').find('.variant-select__option-label:contains('+myVal+')').trigger('click');
  });
  
};

$(theme.init);

theme.resetMenu = function() {
  $('.drawer-nav__sublist').removeClass('is--active');
  $('.drawer-nav__item').removeClass('drawer-nav--expanded').removeClass('slide-out');
  $('.drawer__back-button').fadeOut();
};
        
theme.showMenuPanel = function(p) {
  var rootButtons = '.drawer-nav__item-top';
  $('.drawer-nav__item').removeClass('anim-in')
  $(rootButtons).removeClass('anim-in');
  $('.menu-panel').removeClass('is--visible');
  
  $(p).addClass('is--visible').find('.drawer-nav__item').addClass('anim-in');
  $('.drawer__back-button').fadeIn();
  $('.drawer-nav__item--secondary').fadeOut();
  $('.drawer--left .currency-picker__wrapper').fadeOut();
  
  if(!$('.menu-panel.is--visible').length) {
    $(rootButtons).addClass('anim-in');
    $('.drawer__back-button').fadeOut();
    $('.drawer-nav__item--secondary').fadeIn();
    $('.drawer--left .currency-picker__wrapper').fadeIn();
  }
};


/*============================================================================
  Override POST to cart/add.js. Returns cart JSON.
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

theme.updateCartFromForm = function(e, t) {
  var n = {
    type: "POST",
    url: "/cart/update.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : theme.updateCartPage(e)
    },
    error: function(e, t) {
      theme.onError(e, t)
    }
  };
  $.ajax(n)
};

theme.onError = function() {
  console.log('flesh this out [ theme.onError ]');
};

theme.showSideCartLoader = function() {
  $('.inline-cart--loading').fadeIn();
};
theme.hideSideCartLoader = function() {
  $('.inline-cart--loading').fadeOut();
};
// AJAX cart

theme.removeItem = function(id) {
  //console.log('remove item: '+id);
  $.post('/cart/change.js',{
    quantity: 0,
    id: id,
    success: theme.onCartUpdate,
    error: theme.updateCartFail
  });
};
theme.removeSideCartItem = function(t,r) {
  var e = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&id=" + t,
    dataType: "json",
    success: function(t) {
      "function" == typeof r ? r(t) : theme.onCartUpdate(t)
    },
    error: function(t, r) {
      theme.onError(t, r)
    }
  };
  jQuery.ajax(e)
};

theme.updateItem = function(t,r,e) {
  theme.showSideCartLoader();
  var a = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + r + "&id=" + t,
    dataType: "json",
    success: function(t) {
      //console.log(t);
      "function" == typeof e ? e(t) : theme.onCartUpdate(t)
    },
    error: function(t, r) {
      theme.onError(t, r);
    }
  };
  jQuery.ajax(a);
};


theme.onCartUpdate = function(e) {
  $.get('/cart?view=inline-cart-contents', function(t) {
	$('.inline-cart--container').html(t);
    $('.site-header__cart-count').html($(t).find('.site-header__cart .site-header__cart-count').html());
  }).done(function() {
    theme.hideSideCartLoader();
    theme.checkCountry();
    if(theme.dev.showMultipleCurrencies) {
    	theme.currencySwitcher.ajaxrefresh();
    }
    if(theme.onCartPage()) {
    	theme.updateCartPage();
    }
    theme.davidsAfterpay();
    
    
  });
};
theme.addItemFromForm = function(form_id,e) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: function(t) {
        "function" == typeof e ? e(t) : theme.addToCartOk()
      },
      error: theme.addToCartFail
   });
};
theme.addFromAddBar = function(form_id,e) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#'+form_id).serialize(),
      success: theme.productPageAdded,
      error: theme.addToCartFail
   });
};
theme.addItem = function(t, r, e) {
  var r = r || 1,
      a = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + t,
        dataType: "json",
        success: function(t) {
          "function" == typeof e ? e(t) : theme.addToCartOk(t)
        },
        error: function(t, r) {
          c.onError(t, r)
        }
      };
  jQuery.ajax(a);
};

theme.addToCartOk = function(product) {
  ///cart?view=inline-cart-contents
  
  $.get( "/cart?view=inline-cart-contents", function(t) {
    //console.log('addToCartOk!');
    $('.inline-cart--container').html(t);
    $('.site-header__cart').html($(t).find('.site-header__cart').html());
    $('.cart-count-number').html($(t).find('.site-header .cart-count-number').html());
    if(theme.onCartPage()) {
    	theme.updateCartPage();
      	$("html, body").animate({ scrollTop: 0 }, 500);
    } else {
    	theme.RightDrawer.open();
        theme.checkCountry();
    	$.magnificPopup.close();
    }
    
  }).done(function() {
    $('.btn--small-add').addClass('ready-to-add').text(addToCart);
    if(preOrder) {
      $('#AddToCart-product-template').text(preOrderText).addClass('ready-to-add');
    } else {
      $('#AddToCart-product-template').text(addToCart).addClass('ready-to-add');
    }
    
    
    if(theme.dev.showMultipleCurrencies) {
    	theme.currencySwitcher.ajaxrefresh();
    }
  });
};
        
theme.productPageAdded = function() {
  $.get( "/cart?view=inline-cart-contents", function(t) {
    //console.log('product added from add-bar!');
    $('.inline-cart--container').html(t);
    $('.site-header__cart').html($(t).find('.site-header__cart').html());

  }).done(function() {
    var completeTheSet = '#complete-the-set';
    if($(completeTheSet).length) {
      theme.RightDrawer.open();
	  $.magnificPopup.close();
    } else {
      theme.RightDrawer.open();
      $.magnificPopup.close();
    }
    $('.btn--small-add').addClass('ready-to-add').text(addToCart);
    if(preOrder) {
      $('#AddToCart-product-template').text(preOrderText).addClass('ready-to-add');
     
    } else {
      $('#AddToCart-product-template').text(addToCart).addClass('ready-to-add');
     
    }
    if(theme.dev.showMultipleCurrencies) {
    	theme.currencySwitcher.ajaxrefresh();
    }
	
  });
};

theme.addToCartFail = function(obj, status) { 
  $('.cart-preloader').fadeOut();
  
};
        

theme.updateCartPage = function (cart) {
  $.get( "/cart", function( data ) {
      $('#cart-page--inner').html($(data).find('#cart-page--inner').html());
      $('#CartContainer').html($(data).find('#CartContainer').html());
      $('.cart-count-number').text($(data).find('.site-header__cart .cart-count-number').text());
      //console.log('Cart Should have updated');
  }).done(function() {
    $('.cart-preloader').fadeOut();
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    theme.cartSticky();
    theme.checkCountry();
    if(theme.dev.showMultipleCurrencies) {
    	theme.currencySwitcher.ajaxrefresh();
    }
    
  });
};

theme.checkBISInit = function() {
  if(productPageTriggerBIS) {
    if(klaviyo._initialized && $('#AddToCart-product-template').hasClass('klaviyo-bis-trigger') && getUrlParameter('variant') != '') {
      setTimeout(function() {
        console.log("Klaviyo ready to rock");
        $('.klaviyo-bis-trigger').trigger('click');
      }, 250);
  		
      
    } else {
      console.log("Check for Klaviyo again");
      setTimeout(theme.checkBISInit, 50);
    }
  }
};

theme.checkAfterpayInit = function(data) {
  console.log('theme.checkAfterpayInit');
  var d = data;
  if($(data).find('.cart-sidebar .afterpay-paragraph').length) {
    setTimeout(function() {
      console.log("Afterpay ready to rock");
      $(data).find('.cart-sidebar .afterpay-paragraph').appendTo('#cart-subtotal--afterpay');
      var h = $('#cart-subtotal--afterpay').outerHeight();
//       $('.ajaxcart__inner--has-fixed-footer').css('top',h);
    }, 250);
  } else {
    console.log("Check for Afterpay again");
    //setTimeout(theme.checkAfterpayInit(d), 500);
  }
  
};

theme.getCartAfterpay = function() {
  if(Cookies.get('country') == 'US') {
    $.get('/cart', function(data) {
      
    })
    .done(function(data) {
      theme.checkAfterpayInit(data); 
    });
  }
};

        
new WOW().init();

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

$(window).resize(function(){
  if($('#quick-view').is(':visible')){
    $('.qv-product-images').slick();
    //theme.HeaderSection();
  }
});
        
theme.checkCountdown = function() {
  var countdownTo = $('#sale-countdown').data('countdown-to').replace('  ',' '),
  	  thedate = moment.tz(countdownTo, "America/Los_Angeles"),
      now = new Date();
  if(thedate > now) {
    $('#sale-countdown').countdown(thedate.toDate(), function(event) {
      //$(this).text(event.strftime('%D days %H:%M:%S'));
      $('#sale-days').text(event.strftime('%D'));
      $('#sale-hours').text(event.strftime('%H'));
      $('#sale-minutes').text(event.strftime('%M'));
      $('#sale-seconds').text(event.strftime('%S'));
    }).fadeIn();
  } else {
    $('.announcement-bar').removeClass('show-countdown-timer');
  }
};

theme.dropdownMenus = function() {
  $('.site-nav__dropdown--replace').each(function(i,v) {
    var myDropdown = $(this).data('replace');
    $(myDropdown).empty();
    $(this).appendTo(myDropdown);
    
//     $(myDropdown).html($(this).html());
  });
};
        
// General Stuff     
$(function() {
  
  theme.dropdownMenus();
  
  $(document).on('click','.faq-accordion .question',function(e) {
    e.preventDefault();
    $(this).toggleClass('faq-open').next().slideToggle();
  });
  
  if($('#page--jobs').length) {
  	$("#page--jobs blockquote").each(function() {
        $(this).parent().prepend($(this).children());
        $(this).remove();
    });
  }
  
  if(theme.dev.showMultipleCurrencies) {
    $('html').addClass('show-multiple-currencies');
  }
  
  
  
  $('a:contains("Live Chat")').on('click',function(e) {
    e.preventDefault();
    $zopim.livechat.window.show();
  });
  
  
  $('.mfp-inline').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-with-zoom'
  });
  
  
  
  theme.checkCountry();
  if(theme.dev.showCountdown) {
  	theme.checkCountdown();
  }
  $(document).on('click','.info-sidebar a.internal',function(e) {
    
    e.preventDefault();
    var ajaxhref = $(this).attr('href');
    $.ajax({
      url: ajaxhref,
      type:'GET',
      beforeSend: function() {
        $('.preloader').fadeIn();
        
      },
      success: function(data) {
        $('.info-sections').html($(data).find('.info-sections').html());

        var title = $(data).filter('title').text();
        document.title = title;
        window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);

      },
      complete: function() {
		//$('.info-sidebar a').removeClass('active');
        $('.preloader').fadeOut('slow');
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    });
  });
  theme.checkBISInit();
  //theme.getCartAfterpay();
  $('.newsletter__submit').bind('click', function (e) {
    if (e) e.preventDefault()
    
    register($(this).closest('form'));
  });
  if($('.related-products').length) {
    $('.related-products').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev">'+prevArrow+'</button>',
      nextArrow: '<button type="button" class="slick-next">'+nextArrow+'</button>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
  
  if($('#shopify-section-1548887364656').length) {
    $('#shopify-section-1548887364656').removeClass('index-section--flush');
  }
  
});  
     
$(window).load(function() {
  if($('body').hasClass('template-product') && $('.fs-has-posts').length) {
    $('#product-insta').fadeIn();
  }
  /*
  var thanksgivingCookie = Cookies.get('thanks');
  console.log($('#thanksgiving-popup--trigger').length);
  if($('#thanksgiving-popup--trigger').length && thanksgivingCookie != '1') {
    console.log('thanks popup');
    $('#thanksgiving-popup--trigger').trigger('click');
    Cookies.set('thanks', '1', { expires: 90 });
  }
  */
  
});


function register($form) { 
//   $('#mc-embedded-subscribe').val('Sending...');
  $form.find('.success_message').hide();
  $form.find('.error_message').hide();
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {
      $('#mc-embedded-subscribe').val('subscribe')
      if (data.result === 'success') {
        // Yeahhhh Success
        
        console.log('success',data.msg);
        $form.find('.success_message').html('<p>Thank you for subscribing. We have sent you a confirmation email.</p>').fadeIn();
//         $('#mce-EMAIL').css('borderColor', '#ffffff')
//         $('#subscribe-result').css('color', 'rgb(53, 114, 210)')
//         $('#subscribe-result').html('<p>Thank you for subscribing. We have sent you a confirmation email.</p>')
//         $('#mce-EMAIL').val('')
      } else {
        // Something went wrong, do something to notify the user.
        console.log('error',data.msg);
        $form.find('.error_message').html('<p>'+data.msg+'</p>').show();
//         $('#mce-EMAIL').css('borderColor', '#ff8282')
//         $('#subscribe-result').css('color', '#ff8282')
//         $('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
      }
    }
  })
};